/**
 * Public site entry point.
 * Only includes components needed for the public-facing site.
 */

require('./bootstrap');

window.Vue = require('vue').default || require('vue');

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

import moment from 'moment';

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDXgQZikhJ6Q5yX-bxv92d0dvxndcPnCEk',
        libraries: 'places',
    },
});

import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
Vue.use(VueImageLightboxCarousel);

import Lingallery from 'lingallery';
Vue.use(Lingallery);

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
});

Vue.use(require('vue-chunks'));

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$userId = document.querySelector("meta[name='user_id']").getAttribute('content');
Vue.prototype.$admin = document.querySelector("meta[name='admin']").getAttribute('content');
Vue.prototype.$agent = document.querySelector("meta[name='agent_id']").getAttribute('content');
Vue.prototype.$slug = document.querySelector("meta[name='slug']").getAttribute('content');

/**
 * Routes
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './site-routes';

const router = new VueRouter({
    mode: 'history',
    routes
});

/**
 * Components
 */
Vue.component('pagination', require('laravel-vue-pagination'));

Vue.component(
    'autocomplete',
    require('./components/autocomplete/Autocomplete.vue').default
);

Vue.component(
    'not-found',
    require('./components/NotFound.vue').default
);

Vue.component(
    'browse',
    require('./components/site/Browse.vue').default
);

Vue.component(
    'listing',
    require('./components/site/Listing.vue').default
);

Vue.component(
    'contact-us',
    require('./components/site/ContactUs.vue').default
);

Vue.component(
    'filters',
    require('./components/FiltersSidebar').default
);

Vue.component(
    'agent-profile',
    require('./components/AgentProfile.vue').default
);

Vue.component(
    'calculator',
    require('./components/site/Calculator.vue').default
);

Vue.component(
    'write-testimonial',
    require('./components/site/WriteTestimonial.vue').default
);

Vue.component('search-component', require('./components/SearchComponent.vue').default);

Vue.component(
    'join-our-team-modal',
    require('./components/JoinOurTeamModal').default
);

Vue.component(
    'jumbotron-component',
    require('./components/JumbotronComponent').default
);

/**
 * Filters
 */
Vue.filter('myDate', function (created) {
    return moment(created).format('MMMM Do YYYY');
});

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        value = parseInt(value);
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value);
});

Vue.filter('yesno', value => (value ? '<i class="fas fa-check green"></i>' : '<i class="fas fa-times red"></i>'));

const app = new Vue({
    el: '#app',
    router
});
